import { MyDetailsWrapper } from "./Atom";

function MyDetails() {

    return (
        <>
            <MyDetailsWrapper>

            </MyDetailsWrapper>
        </>
    );
}
export default MyDetails;
